import { render } from "./examreslut.vue?vue&type=template&id=dafc5f20&scoped=true"
import script from "./examreslut.vue?vue&type=script&lang=js"
export * from "./examreslut.vue?vue&type=script&lang=js"

import "./examreslut.vue?vue&type=style&index=0&id=dafc5f20&lang=scss&scoped=true"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dafc5f20"]])

export default __exports__